import { useCallback, useMemo } from 'react';

import { VARIANT } from '../../constants';

import { dark } from './constants/dark';
import { ThemeContext } from './context/ThemeContext';
import { Theme, ThemeProviderProps } from './types';

export const ThemeProvider = ({ theme, variant = VARIANT.DARK, children }: ThemeProviderProps) => {
  const recursiveTheme = useCallback((base: any, incoming: any = {}): Theme => {
    const merged_theme = { ...base };
    Object.keys(incoming).forEach((key) => {
      const incoming_value = incoming[key];
      if (base[key] && typeof base[key] === 'object' && typeof incoming_value === 'object') {
        merged_theme[key] = recursiveTheme(base[key], incoming_value);
      } else if (incoming_value !== undefined) {
        merged_theme[key] = incoming_value;
      }
    });
    return merged_theme;
  }, []);

  const provider_theme = useMemo(() => recursiveTheme(dark, theme), [recursiveTheme, theme]);

  const contextValue = useMemo(
    () => ({
      theme: provider_theme,
      variant,
    }),
    [provider_theme, variant]
  );

  return <ThemeContext.Provider value={contextValue}>{children}</ThemeContext.Provider>;
};
